import React from 'react'

import CheckIconImage from 'assets/icons/check-green.svg'
import BankImage from 'assets/images/bank-link-core-black.svg'
import { LinkedSubaccount } from 'generated/types'

import {
  AccountDetails,
  AccountName,
  AccountWrapper,
  BankImageContainer,
  CheckIcon,
  UncheckedIcon,
} from './styled-components'

type AccountProps = {
  subaccount: LinkedSubaccount
  selectedAccountId?: string
  handleSelectChange: (field: string, value: string) => void
  financialInstitutionLogoUrl?: string
}

export default ({
  handleSelectChange,
  selectedAccountId,
  subaccount,
  financialInstitutionLogoUrl,
}: AccountProps) => (
  <AccountWrapper
    key={subaccount.id}
    onClick={() => handleSelectChange('fundingSource', subaccount.name)}
  >
    <BankImageContainer src={financialInstitutionLogoUrl ?? BankImage} />
    <div>
      <AccountName>{subaccount.name}</AccountName>
      {subaccount.accountNumberLastFour && (
        <AccountDetails>Ending in {subaccount.accountNumberLastFour}</AccountDetails>
      )}
    </div>
    {selectedAccountId === subaccount.id ? <CheckIcon src={CheckIconImage} /> : <UncheckedIcon />}
  </AccountWrapper>
)
